module.exports = __webpack_public_path__ + "img/slide2.5519f74f.jpg";